import React from 'react';
import styled from 'styled-components';
import './RightNav.css';
 import { Link } from 'react-router-dom';

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  margin-top: 0;
  margin-bottom: 0px;

  li {
    padding: 18px 10px;
  }
  
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    background-color: #fff;
    position: fixed;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
    top: 0;
    right: 0;
    height: 100vh;
    width: 250px;
    padding-top: 3rem;
    transition: transform 0.3s ease-in-out;

    a {
      color: #1A2A6C;
      margin-bottom: 10px;
    }
  }
`;

const RightNav = ({ open }) => {
  return (
    <Ul open={open} className="nav listed-nav">
        <a href="/">Home</a>        
        <a href="/#market-knowledge-section">About Us</a>
        {/* <a href="#gateway-section">Core Offerings</a> */}
        <Link to="/blogs">Our Blog</Link>
        <a href="/#contact-section">Contact</a>
    </Ul>
  )
}

export default RightNav